import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang, WHATSAPP, waLink } from "@/i18n";

const WhatsAppFloat = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 left-5 z-50 flex flex-col items-start gap-3">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.95 }}
            className="glass-card rounded-2xl border border-gold/25 p-5 w-72 shadow-[0_20px_60px_rgba(0,0,0,0.6)]"
            data-testid="whatsapp-contact-panel"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-gold/90 font-mono">{t.whatsapp.title}</p>
            <div className="mt-4 space-y-2">
              {WHATSAPP.map((w, i) => (
                <a
                  key={w.num}
                  href={waLink(i, "Namaste Explore India!")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`whatsapp-agent-${i}`}
                  className="flex items-center justify-between rounded-xl bg-[#0B0C10]/70 border border-gold/15 px-4 py-3 hover:border-gold/50 transition-colors"
                >
                  <span>
                    <span className="block text-sm font-semibold text-slate-100">{t.whatsapp.labels[i]}</span>
                    <span className="block text-xs text-slate-500 font-mono mt-0.5">{w.label}</span>
                  </span>
                  <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        data-testid="whatsapp-floating-button"
        onClick={() => setOpen(!open)}
        aria-label="WhatsApp Concierge"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      >
        {open ? (
          <X size={24} />
        ) : (
          <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.03c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 4.54 0 8.24 3.7 8.24 8.24 0 4.55-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.25-.64.8-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29z"/></svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppFloat;
